module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Lite CRM")]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/login_logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "admin",
    attrs: {
      "src": require("../../assets/images/admin1.png"),
      "height": "196",
      "width": "156"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "myForm",
    attrs: {
      "model": _vm.form,
      "label-width": "0",
      "rules": _vm.rules,
      "show-message": true
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit('form')
      }
    }
  }, [_c('el-form-item', {
    class: {
      'focus': _vm.focus.name
    },
    attrs: {
      "prop": "name"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.inputFocus('name')
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focus.name),
      expression: "focus.name"
    }],
    on: {
      "blur": function($event) {
        return _vm.inputBlur('name')
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "placeholder",
    class: {
      'inner-empty': _vm.form.name == ''
    },
    on: {
      "click": function($event) {
        return _vm.inputFocus('name')
      }
    }
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.name != ''),
      expression: "form.name!=''"
    }],
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.clearText('name')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    class: {
      'focus': _vm.focus.password
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.inputFocus('password')
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focus.password),
      expression: "focus.password"
    }],
    attrs: {
      "type": "password"
    },
    on: {
      "blur": function($event) {
        return _vm.inputBlur('password')
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "placeholder",
    class: {
      'inner-empty': _vm.form.password == ''
    },
    on: {
      "click": function($event) {
        return _vm.inputFocus('password')
      }
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.password != ''),
      expression: "form.password!=''"
    }],
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.clearText('password')
      }
    }
  })], 1)]), _vm._v(" "), (_vm.showCode) ? _c('el-form-item', {
    class: {
      'focus': _vm.focus.code
    },
    attrs: {
      "prop": "code"
    }
  }, [_c('el-row', {
    staticClass: "code-item"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.inputFocus('code')
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focus.code),
      expression: "focus.code"
    }],
    on: {
      "blur": function($event) {
        return _vm.inputBlur('code')
      }
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "placeholder",
    class: {
      'inner-empty': _vm.form.code == ''
    },
    on: {
      "click": function($event) {
        return _vm.inputFocus('code')
      }
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.code != ''),
      expression: "form.code!=''"
    }],
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.clearText('code')
      }
    }
  })], 1)]), _vm._v(" "), _c('img', {
    staticClass: "code-img",
    attrs: {
      "src": _vm.imgSrc,
      "width": "126px",
      "height": "48px"
    },
    on: {
      "click": _vm.refreshImg
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    staticClass: "submit",
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.loginText))]), _vm._v(" "), _c('p', {
    staticClass: "forget",
    attrs: {
      "onclick": "window.location.href='/butterfly/admin/sign-in/forgetPwd.html'"
    }
  }, [_vm._v("忘记密码?")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-029aed36!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/admin/sign-in/index.vue
// module id = 1736
// module chunks = 24